module.exports = __webpack_public_path__ + "img/instagram-stories-sticker-1.3112b62b.png";